import { createStore, applyMiddleware } from 'redux'
import reducer from './rootreducer'
import thunk from 'redux-thunk'

//Store, globalized state

const store = createStore(reducer, applyMiddleware(thunk))

export default store